import { Heading, Spacer, Text, Trash, useTheme } from '@sparemin/blockhead';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import usePlanCancellation from 'blocks/Pricing/usePlanCancellation';
import Modal from 'components/Modal';
import { hideModal } from 'redux/modules/modal';
import { tierSelector } from 'redux/modules/pricing';
import { Dispatch } from 'redux/types';
import { PlanCancellationReason } from 'types';
import { BASIC_FEATURES, block, PRO_FEATURES } from './utils';

export type CancellationLossAversionModalContentsProps = {
  details?: string;
  onHide?: () => void;
  reason?: PlanCancellationReason;
};

const CancellationLossAversionModalContents: React.FC<CancellationLossAversionModalContentsProps> = ({
  details,
  onHide,
  reason,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch<Dispatch>();
  const [tier = 'pro'] = useState(useSelector(tierSelector));
  const features = tier === 'basic' ? BASIC_FEATURES : PRO_FEATURES;

  const { onSubmit: cancelPlan } = usePlanCancellation({ reason });

  const handleCancelPlan = useCallback(async () => {
    await cancelPlan(details);
    dispatch(hideModal());
  }, [cancelPlan, details, dispatch]);

  return (
    <>
      <Modal.Body className={block('body')}>
        <Spacer align="center" orientation="vertical" space="50px">
          <Text align="center" lineHeight={1.31} variant="fabLabel">
            Are you sure you want to lose access to your
            <br />
            customizations and {tier} features?
          </Text>
          <ul className={block('list')}>
            {features.map(feature => (
              <Spacer
                align="center"
                as="li"
                justify="space-between"
                key={feature}
                orientation="horizontal"
              >
                <Heading
                  as="span"
                  className={block('feature')}
                  level={1}
                  lineHeight={2}
                >
                  {feature}
                </Heading>
                <Trash style={{ color: theme.palette.danger, height: 20 }} />
              </Spacer>
            ))}
          </ul>
        </Spacer>
      </Modal.Body>
      <Modal.Footer>
        <Modal.FooterButtons>
          <Modal.FooterButton onClick={onHide}>close</Modal.FooterButton>
          <Modal.FooterButton onClick={handleCancelPlan} theme="delete">
            cancel {tier} plan
          </Modal.FooterButton>
        </Modal.FooterButtons>
      </Modal.Footer>
    </>
  );
};

export default CancellationLossAversionModalContents;
